// @flow
import WebComponent from 'fg-frontend/src/webComponents/WebComponent';

export default class SvgIcons extends WebComponent {
	didMount() {
    // Ajaxing SVG sprite

    let spriteContainer = this.element; // lives in svgAddOn.ftl
    var xhr = new XMLHttpRequest();
    var body = document.body;
    // var busting = document.body.getAttribute('data-svg-bust');
    // var svgSpritePath =  '/build/img/svg/svg-sprite-'+ busting +'.svg';
    var svgSpritePath =  '/build/img/svg/svg-sprite.svg';
    //if (busting === 'preview') svgSpritePath =  '/build/img/svg/svg-sprite.svg';

    if ('withCredentials' in xhr) {
      xhr.withCredentials;
      xhr.open('GET', svgSpritePath, true);
    } else if (typeof XDomainRequest != 'undefined') {
      xhr = new XDomainRequest();
      xhr.open('GET', svgSpritePath);
    } else {
      body.className += ' no-svg-sprite';
      //return;
    }
    xhr.onload = function () {
      spriteContainer.innerHTML = xhr.responseText;
    };
    xhr.onerror = function () {
      body.className += ' no-svg-sprite';
    };

    setTimeout(function () {
      xhr.send();
    }, 0);
	}
}



// WEBPACK FOOTER //
// ./fe/web-gmeinder/src/js/components/SvgIcons.js